import styled from 'styled-components';
import {
  WholePageContainer,
} from '../Grid';

const headerHeight = 3.75; // in rem
const footerBottomMargin = 1; // in rem

const gridLines = {
  pageTop: 'country-profiles-conclusion-page-top',
  headerTop: 'country-profiles-conclusion-header-top',
  headerBottom: 'country-profiles-conclusion-header-bottom',
  contentTop: 'country-profiles-conclusion-content-top',
  contentBottom: 'country-profiles-conclusion-content-bottom',
  footerTop: 'country-profiles-conclusion-footer-top',
  footerBottom: 'country-profiles-conclusion-footer-bottom',
  pageBottom: 'country-profiles-conclusion-page-bottom',
};

export const Grid = styled(WholePageContainer)`
  display: grid;
  grid-template-rows:
    [${gridLines.pageTop} ${gridLines.headerTop}] ${headerHeight}rem
    [${gridLines.headerBottom} ${gridLines.contentTop}] auto
    [${gridLines.contentBottom} ${gridLines.footerTop}] 1fr
    [${gridLines.footerBottom}] ${footerBottomMargin}rem
    [${gridLines.pageBottom}];
  height: 100vh;
`;

export const ContentContainer = styled.div`
  grid-row: ${gridLines.contentTop} / ${gridLines.contentBottom};
`;

export const HeaderContainer = styled.div`
  grid-row: ${gridLines.headerTop} / ${gridLines.headerBottom};
`;
export const FooterContainer = styled.div`
  grid-row: ${gridLines.footerTop} / ${gridLines.footerBottom};
`;
